import axiosInstance from './axios';

export const getFoodRequests = async (restaurant_id) => {
  if (!restaurant_id) {
    throw new Error('Restaurant ID is required to fetch food requests');
  }

  const payload = { restaurant_id: 1, status_id: 14 };

  const response = await axiosInstance.post(
    '/vas/1/transaction/view/status/active',
    payload,
  );

  return response;
};


export const getValetRequests = async () => {
  const responses = await Promise.all([
    axiosInstance.post('/vas/3/transaction/view/status/active', { status_id: 6 }),
    axiosInstance.post('/vas/3/transaction/view/status/active', { status_id: 8 }),
  ]);

  const combinedRequests = responses
    .filter(response => Array.isArray(response.data.Data))
    .flatMap(response => response.data.Data)
    .filter(request => request.status_id === 6 || request.status_id === 8);

  return combinedRequests;
};

export const getBaggageRequests = async () => {
  const responses = await Promise.all([
    axiosInstance.post('/vas/2/transaction/view/status/active', { status_id: 10 }),
    axiosInstance.post('/vas/2/transaction/view/status/active', { status_id: 12 }),
  ]);

  const combinedRequests = responses
    .filter(response => Array.isArray(response.data.Data))
    .flatMap(response => response.data.Data)
    .filter(request => request.status_id === 10 || request.status_id === 12);

  return combinedRequests;
};

export const getSOSRequests = async () => {
  const response = await axiosInstance.post('/vas/4/transaction/view/status/active', {
    status_id: 17,
  });

  return Array.isArray(response.data.Data) ? response.data.Data : [];
};

export const getElderlyAssistRequests = async () => {
  const response = await axiosInstance.post('/vas/5/transaction/view/status/active', {
    status_id: 20,
  });

  return Array.isArray(response.data.Data) ? response.data.Data : [];
};
